"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardViewController = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@veeam/core");
const Dialog_1 = require("../../../Dialog");
const DialogWizard_1 = require("../../../DialogWizard");
const helpers_1 = require("../../../helpers");
const WizardActionsViewController_1 = require("./WizardActionsViewController");
const WizardTabsViewController_1 = require("./WizardTabsViewController");
class WizardViewController extends core_1.ReactViewController {
    constructor(config) {
        super({ loading: true });
        this.config = config;
        this.tabsViewController = new WizardTabsViewController_1.WizardTabsViewController({ navigation: [] });
        this.headerViewController = new core_1.RootViewController();
        this.bodyViewController = new core_1.RootViewController();
        this.actionsViewController = new WizardActionsViewController_1.WizardActionsViewController({
            prev: { hidden: true },
            next: { hidden: true },
            skip: { hidden: true },
            done: { hidden: true },
            cancel: { hidden: false }
        });
        this.tabsViewController.width = this.config.tabWidth;
        this.tabsElement = this.tabsViewController.render();
        this.bodyElement = this.bodyViewController.render();
        this.actionsElement = this.actionsViewController.render();
    }
    createElement(state) {
        var _a;
        return (react_1.default.createElement(DialogWizard_1.DialogWizardLayout, { loading: state.loading, pending: state.pending, tabs: this.tabsElement, dialogHeader: this.config.title || '', size: this.config.size || { height: Dialog_1.DIALOG_SIZE.l, width: Dialog_1.DIALOG_SIZE.l }, body: this.bodyElement, onRequestClose: (_a = this.listener) === null || _a === void 0 ? void 0 : _a.didSelectCancel.bind(this.listener), footer: this.actionsElement, onKeyPress: (e) => {
                var _a;
                if (e.keyCode === helpers_1.KeyCode.Enter) {
                    (_a = this.listener) === null || _a === void 0 ? void 0 : _a.didEnterKeydown(e.ctrlKey);
                }
            } }));
    }
    get listener() {
        return this._listener;
    }
    set listener(listener) {
        this._listener = listener;
        this.tabsViewController.listener = listener;
        this.actionsViewController.listener = listener;
    }
    presentPending(state) {
        this.setState(state);
        this.tabsViewController.presentPending(state);
        this.actionsViewController.presentPending(state);
    }
    presentNavigation(navigationState) {
        this.tabsViewController.present({ navigation: navigationState.navigation });
        this.actionsViewController.present(navigationState.actions);
    }
    registerTabViewController(tabId, viewController) {
        this.tabsViewController.registerTab(tabId, viewController);
    }
    replaceBody(viewController) {
        this.bodyViewController.replace(viewController);
        this.actionsViewController.texts = viewController.texts;
    }
    replaceHeader(viewController) {
        this.headerViewController.replace(viewController);
    }
}
exports.WizardViewController = WizardViewController;
//# sourceMappingURL=WizardViewController.js.map